import { Edit, Eye, Trash } from "tabler-icons-react";

export const IndustryTypeHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "typeName",
    numeric: false,
    disablePadding: true,
    label: "Industry Type",
  },
  {
    id: "typeDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  // {
  //   id: "createdDate",
  //   date: true,
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Created Date",
  // },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
